var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-modal',{attrs:{"header":false,"footer":false,"backdrop":false,"closable":false,"modalBodyClass":_vm.$prefixClass.modal + '-optimize-actual'},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('vue-optimize-content',{on:{"start-optimize":_vm.startOptimize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }